"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var SynchronousRegistry_1 = tslib_1.__importDefault(require("./SynchronousRegistry"));
exports.SynchronousRegistry = SynchronousRegistry_1["default"];
var SynchronousMetaRegistry_1 = tslib_1.__importDefault(require("./SynchronousMetaRegistry"));
exports.SynchronousMetaRegistry = SynchronousMetaRegistry_1["default"];
//# sourceMappingURL=index.js.map